import { useState, useEffect } from "react";
import "./InputSwitch.scss";

const InputSwitch = ({
    checked = false,
    onChange,
    className = "",
    label,
    labelPosition = "right",
}) => {
    const [isOn, setIsOn] = useState(checked);

    useEffect(() => {
        setIsOn(checked);
    }, [checked]);

    const handleToggle = () => {
        const newValue = !isOn;
        setIsOn(newValue);
        onChange && onChange(newValue);
    };

    return (
        <div className="input-switch-container">
            {label && labelPosition === "left" && (
                <span className="input-switch-label">{label}</span>
            )}
            <button
                onClick={handleToggle}
                className={`input-switch ${isOn ? "on" : ""} ${className}`}
            >
                <div className="switch-handle"></div>
            </button>
            {label && labelPosition === "right" && (
                <span className="input-switch-label">{label}</span>
            )}
        </div>
    );
};

export default InputSwitch;
